import { render, staticRenderFns } from "./ByLinkedAcct.vue?vue&type=template&id=0cbb73a5&scoped=true&"
import script from "./ByLinkedAcct.vue?vue&type=script&lang=js&"
export * from "./ByLinkedAcct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbb73a5",
  null
  
)

export default component.exports